import { clsx } from 'clsx';
import { Tooltip } from '@/components/ui/Tooltip';

const LEVELS = [
  { value: 0, label: 'Manual', desc: 'AI drafts, human approves all', tooltip: 'Manual: All actions require human approval before execution' },
  { value: 1, label: 'Supervised', desc: 'AI drafts, daily digest review', tooltip: 'Supervised: AI drafts actions, you review them in a daily digest' },
  { value: 2, label: 'Semi-Auto', desc: 'AI executes routine, escalates edge cases', tooltip: 'Semi-Auto: AI handles routine tasks automatically, escalates edge cases for review' },
  { value: 3, label: 'Autonomous', desc: 'AI handles 85%+, escalates exceptions', tooltip: 'Autonomous: AI handles 85%+ of decisions, only escalates critical exceptions' },
];

interface AutonomySliderProps {
  value: 0 | 1 | 2 | 3;
  onChange: (value: 0 | 1 | 2 | 3) => void;
  label?: string;
}

export function AutonomySlider({ value, onChange, label }: AutonomySliderProps) {
  return (
    <div>
      {label && <p className="text-sm font-medium text-surface-300 mb-2">{label}</p>}
      <div className="flex gap-1">
        {LEVELS.map((level) => (
          <Tooltip key={level.value} content={level.tooltip} side="bottom">
            <button
              onClick={() => onChange(level.value as 0 | 1 | 2 | 3)}
              className={clsx(
                'flex-1 px-2 py-2 rounded-lg text-center transition-all border cursor-pointer',
                value === level.value
                  ? 'bg-nexus-600/20 border-nexus-500 text-nexus-400'
                  : 'bg-surface-800 border-surface-700 text-surface-400 hover:border-surface-600 hover:text-surface-300',
              )}
            >
              <p className="text-xs font-semibold">{level.label}</p>
              <p className="text-[10px] mt-0.5 opacity-70 leading-tight">{level.desc}</p>
            </button>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}
